import pluralize from 'pluralize';

const selectionsRemaining = ($container, $maxItems) => {
  const $selectionRemainingCount = $container.find($('@selectionRemainingCount'));
  const $selectionRemaining = $container.find($('.picks_remaining'));
  const $form = $container.find($('@makePickForm'));

  const count = $maxItems - $form.find(':checked').length;

  const returnCount = (num) => {
    if (num < 0) {
      return 0;
    }
    return num;
  };

  const text = `${returnCount(count)} ${pluralize('selection', returnCount(count))} remaining`;

  $selectionRemainingCount.text(text);

  if (returnCount(count)) {
    $selectionRemaining.addClass('picks_remaining-inprogress');
  } else {
    $selectionRemaining.removeClass('picks_remaining-inprogress');
  }
};

export default selectionsRemaining;
